<template>
  <div class="modal fade" id="createBlogPostModal">
    <div class="modal-dialog modal-xxl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="!editing" class="modal-title">
            New Post
          </h5>
          <h5 v-if="editing" class="modal-title">
            Edit Post
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="savePost">
            <div class="form-group">
              <label for="title">Title</label>
              <input
                type="text"
                class="form-control"
                id="title"
                placeholder="Title"
                required
                v-model="title"
              />
            </div>
            <div class="form-group">
              <label for="summary">Summary</label>
              <textarea
                type="text"
                class="form-control"
                id="summary"
                placeholder="Summary"
                rows="2"
                required
                v-model="summary"
              />
            </div>
            <div class="form-group">
              <label>Post</label>
              <ckeditor
                :editor="editor"
                v-model="post"
                :config="editorConfig"
              ></ckeditor>
              <p>{{ post.length }} / 8000</p>
            </div>

            <div class="form-group">
              <label for="releaseDate">Release Date</label>
              <datepicker
                v-model="releaseDate"
                id="applicationDeadline"
                format="MM/dd/yyyy"
                @selected="releaseDateSelected"
              />
            </div>
            <div class="form-group">
              <label for="pictureSearch">Image Search</label>
              <div class="form-row">
                <div class="col-auto">
                  <input
                    class="form-control form-control-sm"
                    id="pictureSearch"
                    v-model="pictureSearch"
                    placeholder="Search for photos here"
                  />
                </div>
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-sm btn-primary"
                    v-on:click="searchPhoto"
                  >
                    Search
                  </button>
                </div>
                <div class="col-auto">
                  <button
                    class="btn btn-sm btn-primary"
                    type="button"
                    v-if="searchPage > 1"
                    v-on:click="prevPhoto"
                  >
                    Prev
                  </button>
                </div>
                <div class="col-auto">
                  <p v-if="photos.length > 0">
                    {{ searchPage }} / {{ totalSearchPages }}
                  </p>
                </div>
                <div class="col-auto">
                  <button
                    class="btn btn-sm btn-primary"
                    type="button"
                    v-if="searchPage < totalSearchPages"
                    v-on:click="nextPhoto"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-3" v-for="photo in photos" :key="photo.id">
                <div class="form-row" style="margin-bottom: -1rem;">
                  <div class="col-auto">
                    <i
                      class="material-icons d- pointer"
                      v-bind:id="'copy' + photo.id"
                      v-on:click="copyPhoto(photo)"
                      @mouseover="showTooltip('#copy' + photo.id)"
                      @mouseleave="hideTooltip('#copy' + photo.id)"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Copy image link"
                    >
                      content_copy
                    </i>
                  </div>
                  <div class="col-auto">
                    <i
                      class="material-icons d- pointer"
                      v-bind:id="'thumbnail' + photo.id"
                      v-on:click="applyThumbnailPhoto(photo)"
                      @mouseover="showTooltip('#thumbnail' + photo.id)"
                      @mouseleave="hideTooltip('#thumbnail' + photo.id)"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Set thumbnail URL"
                    >
                      settings_applications
                    </i>
                  </div>
                  <div class="col-auto">
                    <i
                      class="material-icons d- pointer"
                      v-bind:id="'header' + photo.id"
                      v-on:click="applyHeaderPhoto(photo)"
                      @mouseover="showTooltip('#header' + photo.id)"
                      @mouseleave="hideTooltip('#header' + photo.id)"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Set header URL"
                    >
                      settings_overscan
                    </i>
                  </div>
                </div>
                <img
                  class="image-list pointer"
                  style="display: block; margin-left:auto; margin-right:auto;"
                  height="auto"
                  max-width="100%"
                  :src="photo.urls.thumb"
                  alt="img"
                  @click="applyPhoto(photo)"
                />
                <p
                  style="text-align: center; color: lightslategray"
                  class="small"
                >
                  Photo by
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    v-bind:href="photo.user.links.html"
                    >{{ photo.user.first_name }} {{ photo.user.last_name }}</a
                  >
                  on
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="www.unsplash.com"
                    >Unsplash</a
                  >
                </p>
              </div>
            </div>
            <div class="form-group">
              <label for="thumbnailPicture">Thumbnail Image</label>
              <input
                type="text"
                class="form-control"
                id="thumbnailPicture"
                placeholder="Image URL"
                required
                v-model="thumbnailPicture"
              />
            </div>
            <div class="form-group">
              <label for="headerPicture">Header Image</label>
              <input
                type="text"
                class="form-control"
                id="headerPicture"
                placeholder="Image URL"
                required
                v-model="headerPicture"
              />
            </div>
            <div class="form-group">
              <div class="form-row">
                <div class="col-auto">
                  <label>Tags/Categories</label>
                  <select
                    name="categoryPicker"
                    class="selectpicker d-block"
                    data-style="btn-outline-primary"
                    multiple
                    data-live-search="true"
                    data-actions-box="true"
                    data-selected-text-format="count"
                    v-model="categories"
                  >
                    <option
                      v-for="category in Categories"
                      :key="category.Category_Id"
                      v-bind:value="category"
                    >
                      {{ category.Name }}
                    </option>
                  </select>
                  <p class="text-secondary">
                    {{ getCategoryList(categories) }}
                  </p>
                </div>
                <div class="col-auto ml-4">
                  <div class="form-row">
                    <div class="col-auto">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        id="newCategory"
                        placeholder="New Category"
                        v-model="newCategory"
                      />
                    </div>
                    <div class="col-auto">
                      <button
                        class="btn btn-sm btn-primary"
                        type="button"
                        v-on:click="createCategory"
                      >
                        New Category
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col" />
              </div>
            </div>
            <div class="text-right">
              <button
                v-if="editing"
                type="button"
                v-on:click="deletePost"
                class="float-left btn btn-danger"
              >
                Delete Post
              </button>
              <div v-if="editing">
                <button
                  v-if="$canApproveBlogPost($store.getters.user.Permissions)"
                  class="btn btn-primary mr-4"
                  type="button"
                  v-on:click="approvePost"
                >
                  Approve Post
                </button>
                <button class="btn btn-primary">
                  Update Post
                </button>
              </div>
              <button v-if="!editing" type="submit" class="btn btn-primary">
                Create Post
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import datepicker from "vuejs-datepicker";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";

import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import ImageInsert from "@ckeditor/ckeditor5-image/src/imageinsert";
import ImageBase from "@ckeditor/ckeditor5-image/src/image";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize";
//import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";
import List from "@ckeditor/ckeditor5-list/src/list";
import Link from "@ckeditor/ckeditor5-link/src/link";
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed";
import Indent from "@ckeditor/ckeditor5-indent/src/indent";
import Table from "@ckeditor/ckeditor5-table/src/table";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar";
import TableProperties from "@ckeditor/ckeditor5-table/src/tableproperties";
import TableCellProperties from "@ckeditor/ckeditor5-table/src/tablecellproperties";
import HorizontalLine from "@ckeditor/ckeditor5-horizontal-line/src/horizontalline";

import Unsplash, { toJson } from "unsplash-js";

export default {
  name: "CreateBlogPostModal",
  components: {
    datepicker,
    ckeditor: CKEditor.component
  },
  props: {
    PostToEdit: Object,
    Categories: Array
  },
  data() {
    return {
      title: "",
      summary: "",
      post: "",
      releaseDate: new Date(),
      thumbnailPicture: "",
      headerPicture: "",
      categories: [],
      editingPost: null,
      editing: false,
      newCategory: "",
      photos: [],
      pictureSearch: "",
      unsplash: null,
      editor: ClassicEditor,
      searchPage: 1,
      totalSearchPages: 1,
      editorConfig: {
        plugins: [
          Essentials,
          Paragraph,
          Bold,
          Italic,
          Alignment,
          Underline,
          Strikethrough,
          List,
          Link,
          ImageBase,
          ImageInsert,
          ImageStyle,
          ImageResize,
          Heading,
          MediaEmbed,
          Indent,
          Table,
          TableToolbar,
          TableProperties,
          TableCellProperties,
          HorizontalLine
        ],
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
        },
        heading: {
          options: [
            {
              model: "paragraph",
              title: "Paragraph",
              class: "ck-heading_paragraph"
            },
            {
              model: "heading1",
              view: "h1",
              title: "Heading 1",
              class: "ck-heading_heading1"
            },
            {
              model: "heading2",
              view: "h2",
              title: "Heading 2",
              class: "ck-heading_heading2"
            }
          ]
        },
        toolbar: [
          "heading",
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "alignment",
          "link",
          "bulletedList",
          "numberedList",
          "indent",
          "|",
          "horizontalLine",
          "insertTable",
          "imageInsert",
          "imageStyle:full",
          "imageStyle:side",
          "mediaEmbed"
        ]
      }
    };
  },
  watch: {
    PostToEdit: function() {
      if (this.PostToEdit != null) {
        this.title = this.PostToEdit.Title;
        this.summary = this.PostToEdit.Summary;
        this.post = this.PostToEdit.Post;
        this.releaseDate = this.PostToEdit.Release_Date;
        this.thumbnailPicture = this.PostToEdit.Thumbnail_Picture;
        this.headerPicture = this.PostToEdit.Header_Picture;
        this.editingPost = this.PostToEdit;
        this.newCategory = "";
        this.categories = this.PostToEdit.Categories;
        console.log(this.PostToEdit);
        $("select[name=categoryPicker]").val(this.categories);
        $(".selectpicker").selectpicker("refresh");
        this.editing = true;
      } else {
        this.clearFields();
        this.editing = false;
      }
    },
    Categories: function() {
      console.log("Categories changed under watch");
      $(".selectpicker").selectpicker("refresh");
    }
  },
  mounted() {
    $("#createBlogPostModal").on("shown.bs.modal", function() {
      $("#title").focus();
      $(".selectpicker").selectpicker("refresh");
    });
    $(".selectpicker").selectpicker("refresh");
    this.unsplash = new Unsplash({
      accessKey: "b70G_K_eQ1zBggn_6KTeosafY0wr-EKGOZYB2xAlLvU"
    });
  },
  methods: {
    async savePost() {
      if (this.editing) {
        await this.updatePost();
      } else {
        await this.createPost();
      }
    },
    async createPost() {
      var view = this;
      $("#createBlogPostModal").modal("hide");
      view.$store.commit("updateLoading", true);
      var postToCreate = {
        Title: view.$data.title,
        Summary: view.$data.summary,
        Post: view.$data.post,
        Release_Date: view.$data.releaseDate,
        Thumbnail_Picture: view.$data.thumbnailPicture,
        Header_Picture: view.$data.headerPicture,
        Author: view.$store.getters.user,
        Approved: false
      };
      await this.$createPost(postToCreate)
        .then(async newPost => {
          await this.$createPostCategories(
            newPost.Blog_Post_Id,
            view.$data.categories
          ).then(() => {
            newPost.Categories = view.$data.categories;
            view.$emit("addedPost", newPost);
            view.$store.commit("updateLoading", false);
            view.clearFields();
          });
        })
        .catch(e => {
          console.log(e);
          $("#createBlogPostModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async updatePost() {
      var view = this;
      $("#createBlogPostModal").modal("hide");
      view.$store.commit("updateLoading", true);
      var postToUpdate = {
        Blog_Post_Id: view.PostToEdit.Blog_Post_Id,
        Title: view.$data.title,
        Summary: view.$data.summary,
        Post: view.$data.post,
        Release_Date: view.$data.releaseDate,
        Thumbnail_Picture: view.$data.thumbnailPicture,
        Header_Picture: view.$data.headerPicture,
        Author: view.PostToEdit.Author,
        Approved: false
      };
      var categoriesToRemove = view.PostToEdit.Categories.filter(
        c => !view.categories.includes(c)
      );
      var categoriesToAdd = view.categories.filter(
        c => !view.PostToEdit.Categories.includes(c)
      );
      await this.$updatePost(postToUpdate)
        .then(async updatedPost => {
          await this.$deletePostCategories(
            updatedPost.Blog_Post_Id,
            categoriesToRemove
          ).then(async () => {
            await this.$createPostCategories(
              updatedPost.Blog_Post_Id,
              categoriesToAdd
            ).then(() => {
              updatedPost.Categories = view.$data.categories;
              view.$emit("updatedPost", updatedPost);
              view.$store.commit("updateLoading", false);
              view.clearFields();
            });
          });
        })
        .catch(e => {
          console.log(e);
          $("#createBlogPostModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async approvePost() {
      this.$store.commit("updateLoading", true);
      $("#createBlogPostModal").modal("hide");
      await this.$approveBlogPost(this.PostToEdit.Blog_Post_Id).then(() => {
        this.$emit("approvedPost", this.PostToEdit.Blog_Post_Id);
        this.$store.commit("updateLoading", false);
      });
    },
    async deletePost() {
      //var view = this;
      $("#createBlogPostModal").modal("hide");
      /*await this.$deleteFAQ(view.editingFAQ)
        .then(() => {
          view.$emit("deletedFAQ", view.editingFAQ.FAQ_Id);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#createFAQModal").modal("show");
          view.$store.commit("updateLoading", false);
        });*/
    },

    async createCategory() {
      var view = this;
      view.$store.commit("updateLoading", true);
      $("#createBlogPostModal").modal("hide");
      setTimeout(async () => {
        await this.$createCategory(view.newCategory)
          .then(newCategory => {
            view.$emit("createdCategory", newCategory);
            view.newCategory = "";
            view.$store.commit("updateLoading", false);
            $("#createBlogPostModal").modal("show");
          })
          .catch(e => {
            console.log(e);
            view.$store.commit("updateLoading", false);
            $("#createBlogPostModal").modal("show");
          });
      }, 500);
    },
    clearFields() {
      this.title = "";
      this.summary = "";
      this.post = "";
      this.releaseDate = new Date();
      this.headerPicture = "";
      this.thumbnailPicture = "";
      this.photos = [];
      this.searchPage = 1;
      this.totalSearchPages = 1;
      this.pictureSearch = "";
      this.categories = [];
      this.editingPost = null;
    },
    releaseDateSelected(newDate) {
      this.releaseDate = newDate;
    },
    getCategoryList(categories) {
      if (categories.length > 0) {
        var cats = categories[0].Name;
        for (let i = 1; i < categories.length; i++) {
          cats += ", " + categories[i].Name;
        }
        return cats;
      } else return "";
    },

    async searchPhoto() {
      await this.unsplash.search
        .photos(this.pictureSearch, this.searchPage, 8)
        .then(toJson)
        .then(json => {
          console.log(json);
          this.searchPage = 1;
          this.totalSearchPages = json.total_pages;
          this.photos = json.results;
        });
    },

    async nextPhoto() {
      this.searchPage++;
      await this.unsplash.search
        .photos(this.pictureSearch, this.searchPage, 8)
        .then(toJson)
        .then(json => {
          console.log(json);
          this.photos = json.results;
        });
    },

    async prevPhoto() {
      this.searchPage--;
      await this.unsplash.search
        .photos(this.pictureSearch, this.searchPage, 8)
        .then(toJson)
        .then(json => {
          console.log(json);
          this.photos = json.results;
        });
    },

    applyThumbnailPhoto(photo) {
      this.thumbnailPicture = photo.urls.thumb;
    },
    applyHeaderPhoto(photo) {
      this.headerPicture = photo.urls.regular;
    },
    copyPhoto(photo) {
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val(photo.urls.regular).select();
      document.execCommand("copy");
      $temp.remove();
    },
    showTooltip(id) {
      $(id).tooltip("show");
    },
    hideTooltip(id) {
      $(id).tooltip("hide");
    }
  }
};
</script>

<style scoped>
a {
  color: lightslategray;
}
</style>
